import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import flightReducer from './slices/flightSlice';
import bookingReducer from './slices/bookingSlice';
import uiReducer from './slices/uiSlice';
import cmsReducer from './slices/cmsSlice';
import cmsAdminReducer from './slices/cmsAdminSlice';
import notificationReducer from './slices/notificationSlice';
import passengerReducer from './slices/passengerSlice';
import utilityReducer from './slices/utilitySlice';
import twoFactorReducer from './slices/twoFactorSlice';
import aircraftReducer from './slices/aircraftSlice';
import flightManagementReducer from './slices/flightManagementSlice';
import adminReducer from './slices/adminSlice';
import blogAdminReducer from './slices/blogAdminSlice';
import blogReducer from './slices/blogSlice';
import revenueReducer from './slices/revenueSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    flights: flightReducer,
    bookings: bookingReducer,
    ui: uiReducer,
    cms: cmsReducer,
    cmsAdmin: cmsAdminReducer,
    notifications: notificationReducer,
    passengers: passengerReducer,
    utility: utilityReducer,
    twoFactor: twoFactorReducer,
    aircraft: aircraftReducer,
    flightManagement: flightManagementReducer,
    admin: adminReducer,
    blogAdmin: blogAdminReducer,
    blog: blogReducer,
    revenue: revenueReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Export types for TypeScript usage (if needed later)
export const selectAuth = (state) => state.auth;
export const selectFlights = (state) => state.flights;
export const selectBookings = (state) => state.bookings;
export const selectUI = (state) => state.ui;
export const selectCMS = (state) => state.cms;
export const selectCMSAdmin = (state) => state.cmsAdmin;
export const selectNotifications = (state) => state.notifications;
export const selectPassengers = (state) => state.passengers;
export const selectUtility = (state) => state.utility;
export const selectTwoFactor = (state) => state.twoFactor;
export const selectAircraft = (state) => state.aircraft;
export const selectFlightManagement = (state) => state.flightManagement;
export const selectAdmin = (state) => state.admin;